import { memo } from 'react';

import { type Workspace } from '@air/api/types';
import { Web } from '@air/next-icons';

import { LibraryDetailsAccessibility } from '~/components/LibraryBeta/LibrarySettingsModal/components/LibraryDetails/components/LibraryDetailsAccessibility';
import { LibraryDetails } from '~/components/LibraryBeta/LibrarySettingsModal/components/LibraryDetails/LibraryDetails';

type GeneralLibraryInfoProps = {
  workspaceName: Workspace['name'];
};

export const GeneralLibraryInfo = memo(({ workspaceName }: GeneralLibraryInfoProps) => {
  return (
    <LibraryDetails
      accessibility={
        <LibraryDetailsAccessibility
          label="Global"
          icon={<Web className="size-4 fill-grey-10" />}
          description={`All users with access to ${workspaceName} are automatically members of this library.`}
        />
      }
    />
  );
});

GeneralLibraryInfo.displayName = 'GeneralLibraryInfo';
